export default __webpack_public_path__ + "static/media/21-EXT-(3-2).55fe09a9.jpg";